import { formatTimeslotPopoverSubtitle } from "components/timeslot-popover/utils/formatTimeslotPopoverSubtitle";
import { DEFAULT_LOCALE } from "constants/defaultLocale";

export default function getGroupSessionInfo(
  session: GroupSessionMetaData,
  timeZone: string,
) {
  return `You have been invited to the following event.
    Zoom meeting invitation - Orchid Health's Zoom Meeting
    When ${formatTimeslotPopoverSubtitle(
      session.group_session_start,
      session.group_session_end,
      timeZone,
    )} ${
    new Intl.DateTimeFormat(DEFAULT_LOCALE, {
      timeZone,
      timeZoneName: "long",
    })
      .formatToParts(new Date())
      .find((el) => el.type === "timeZoneName")?.value
  }`;
}
